import { GREY_50 } from '@glass/web/modules/theme/colors';

const alternatingGrayBackground = ({ nthChild = 'odd', backgroundColor = GREY_50 } = {}) => ({
  [`&:nth-of-type(${nthChild})`]: {
    backgroundColor,
  },
});

export default alternatingGrayBackground;
